import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-021a7aa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "导出中心", -1))
const _hoisted_2 = { class: "exportCenterView__content" }
const _hoisted_3 = { class: "fl-row action-links" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_form = _resolveComponent("app-form")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer exportCenterView" }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_app_form, {
          "search-list": _ctx.searchList,
          "search-data": _ctx.filterParams,
          onHandleSearch: _ctx.onRefreshTable
        }, null, 8, ["search-list", "search-data", "onHandleSearch"]),
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "taskId",
          "show-pagination": true,
          columns: _ctx.tableColumns,
          data: _ctx.loadTableData
        }, {
          action: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_3, [
              (record.status === 2 && record.downloadUrl)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "javascript:;",
                    onClick: _withModifiers(($event: any) => (_ctx.handleDownload(record)), ["prevent"])
                  }, "下载", 8, _hoisted_4))
                : _createCommentVNode("", true),
              (record.status === 2 || record.status === 3)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "javascript:;",
                    class: "btn-red",
                    onClick: _withModifiers(($event: any) => (_ctx.handleRemove(record)), ["prevent"])
                  }, "删除", 8, _hoisted_5))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["columns", "data"])
      ])
    ]),
    _: 1
  }))
}